function splider() {
  const newVideoSlider = document.querySelector('.section-video-slider');
  if (newVideoSlider) {
    const customVideoSlide = new Splide(newVideoSlider, {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 6,
      autoScroll: {
        autoplay: true,
        speed: 1,
      },
      breakpoints: {
        1024: { perPage: 4 },
        767: { perPage: 3 },
        500: { perPage: 2 },
      }
    });
    customVideoSlide.mount();
  }
}
splider();
